import React from "react";
import { Box, UnstyledButton } from "@mantine/core";
import { IconBan, IconCalendarPlus } from "@tabler/icons-react";
import { GridWindow } from "./geometry";
import styles from "./MobileGrid.module.css";

/** Slot menu size used to keep it inside the lane. */
const MENU_W = 190;
const MENU_H = 140;

/**
 * Where the menu sits for a press at `startMin` (lane coordinates): just
 * under the snapped slot, flipped above near the bottom, kept inside the lane.
 */
export function slotMenuPlacement(
  startMin: number,
  clientX: number,
  lane: DOMRect,
  window: GridWindow,
  ppm: number,
): { left: number; top: number } {
  const laneH = (window.endMin - window.startMin) * ppm;
  const rawTop = (startMin - window.startMin) * ppm + 6;
  const top = rawTop + MENU_H > laneH ? Math.max(0, rawTop - 152) : rawTop;
  const left = Math.max(
    4,
    Math.min(lane.width - MENU_W - 4, clientX - lane.left - 90),
  );
  return { left, top };
}

export interface MobileSlotMenuProps {
  left: number;
  top: number;
  onAppointment: () => void;
  onTimeBlock: () => void;
  onClose: () => void;
}

/**
 * Empty-slot press menu (day and week grids): Appointment / Time block over
 * a transparent backdrop that dismisses it.
 */
export const MobileSlotMenu: React.FC<MobileSlotMenuProps> = ({
  left,
  top,
  onAppointment,
  onTimeBlock,
  onClose,
}) => (
  <>
    <Box
      className={styles.slotBackdrop}
      onClick={(e: React.MouseEvent) => {
        e.stopPropagation();
        onClose();
      }}
    />
    <Box
      className={styles.slotMenu}
      role="menu"
      style={{ left, top }}
      onClick={(e: React.MouseEvent) => e.stopPropagation()}
    >
      <UnstyledButton
        className={styles.slotItem}
        role="menuitem"
        onClick={onAppointment}
      >
        <Box component="span" className={styles.slotIcon}>
          <IconCalendarPlus size={17} stroke={1.8} />
        </Box>
        Appointment
      </UnstyledButton>
      <UnstyledButton
        className={styles.slotItem}
        role="menuitem"
        onClick={onTimeBlock}
      >
        <Box component="span" className={styles.slotIcon}>
          <IconBan size={17} stroke={1.8} />
        </Box>
        Time block
      </UnstyledButton>
    </Box>
  </>
);
